export default [
    {
        comment: '',
        error_id: 'ES-00',
        data: [
            {
                "cross_section": "43827",
                "type": 'base',
            },
            {
                "cross_section": "42567",
                "type": 'base',
            },
            {
                "cross_section": "41567",
                "type": 'comparison',
            },
            {
                "cross_section": "39875",
                "type": 'comparison',
            }
        ]
    },
    {
        comment: '',
        error_id: 'T-ES-01',
        data: [
            {
                "cross_section": "43827",
                "base_left": 149.50,
                "base_right": 358.90,
                "compare_left": 198.35,
                "compare_right": 425.35
            }
        ]
    },
    {
        comment: '',
        error_id: 'T-TopW-01',
        data: [
            {
                "cross_section": "43827",
                "base": {
                    "sel_topW_L": "150.50",
                    "sel_topW_R": "58.90",
                    "sel_topW": "209.40"
                },
                "compare": {
                    "tar_topW_L": "101.65",
                    "tar_topW_R": "125.35",
                    "tar_topW": "227.00"
                },
                "diff": "17.60"
            }
        ]
    }
]